<template>
  <div :class="{ [$style.wrapper]: true, [$style.error]: error }">
    <div :class="$style.left">
      <img :src="icon" :alt="title" v-if="icon">
      {{title}}
    </div>
    <div :class="$style.right">
      <template v-if="!users">
        <div v-for="i in dropzoneNumber" :key="i" :class="[$style.dropzone, 'dropzone']" :data-result="id"></div>
      </template>
      <template v-else>
        <User
          v-for="user in users"
          :key="user.id"
          :user="user"
          :class="$style.user"
        />
      </template>
    </div>
  </div>
</template>
<script>
import User from '../../../User/User.vue'

export default {
  name: 'DraggableContainer',
  components: { User },
  props: {
    title: String,
    dropzoneNumber: Number,
    id: Number,
    error: Boolean,
    users: Array,
    icon: String,
  },
}
</script>
<style lang="scss" module>
@import 'DrabbagleContainer';
</style>
